module.exports = __webpack_public_path__ + "shipping-truck.png";